import Benefits from "@/components/enfini/Benefits";
import Creators from "@/components/enfini/Creators";
import Footer from "@/components/enfini/Footer";
import Header from "@/components/enfini/Header";
import HowItWorks from "@/components/enfini/HowItWorks";
import Platforms from "@/components/enfini/Platforms";
import RevenueCalculator from "@/components/enfini/RevenueCalculator";
import Services from "@/components/enfini/Services";
import Upsell from "@/components/enfini/Upsell";
import { useEffect } from "react";
import EnfiniBoost from "../enfinity/our-solutions/enfiniboost";

export default function Boost() {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  const benefits = [
    {
      icon: "Sprout",
      asset: "HourglassImg",
      title: "Revenue from Day One",
      description:
        "Skip the minimum requirements and payout delays. Once your videos are live on our partner platforms, they start earning immediately.",
    },
    {
      icon: "BrainCircuit",
      asset: "RocketImg",
      title: "Expand to 2B+ Audiences",
      description:
        "Get your content in front of massive new audiences through MSN, YouTube, Facebook, TikTok, BiliBili, and other high-traffic platforms.",
    },
    {
      icon: "View",
      asset: "ChartImg",
      title: "Your Progress, Visualized",
      description:
        "Track how you’re doing in real time. From performance trends to actionable insights, everything’s in one clean dashboard.",
    },
  ];

  return (
    <div className="space-y-20">
      <EnfiniBoost/>
    </div>
  );
}
